package com.kinoshazam.shared.`data`.db.sqldelight

import `data`.db.delight.KinoshkaDbQueries
import app.cash.sqldelight.SuspendingTransacter
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import com.kinoshazam.shared.`data`.db.sqldelight.shared.newInstance
import com.kinoshazam.shared.`data`.db.sqldelight.shared.schema
import kotlin.Unit

public interface KinoshkaDb : SuspendingTransacter {
  public val kinoshkaDbQueries: KinoshkaDbQueries

  public companion object {
    public val Schema: SqlSchema<QueryResult.AsyncValue<Unit>>
      get() = KinoshkaDb::class.schema

    public operator fun invoke(driver: SqlDriver): KinoshkaDb =
        KinoshkaDb::class.newInstance(driver)
  }
}
